<template>
  <div class="sidebar-container">
    <h3>Hovednavigasjon</h3>
    <h4 @click="AdminPanelShow()">
      <font-awesome-icon
        icon="space-shuttle"
        style="transform: rotate(270deg)"
      />
      Adminpanel <span>></span>
    </h4>
    <div class="dropdown-menu" v-if="this.adminPanel">
      <p><router-link to="/adminpanel/???">???</router-link></p>
      <p><router-link to="/adminpanel/???">???</router-link></p>
      <p><router-link to="/adminpanel/???">???</router-link></p>
    </div>
    <h4 @click="StudentPanelShow()">
      <font-awesome-icon icon="users" /> Elever <span>></span>
    </h4>
    <div class="dropdown-menu" v-if="this.students">
      <p><router-link to="/adminpanel/student-liste">Alle studenter</router-link></p>
      <p><router-link to="/adminpanel/get-liste">GET studenter</router-link></p>
      <p><router-link to="/adminpanel/søkere-liste">Søkere</router-link></p>
    </div>
    <h4 @click="SubmissionsPanelShow()">
      <font-awesome-icon icon="file-alt" /> Innlevering <span>></span>
    </h4>
    <div class="dropdown-menu" v-if="this.submissions">
      <p><router-link to="/adminpanel/alle-innleveringer">Alle innleveringer</router-link></p>
      <p><router-link to="/adminpanel/obligatoriske-oppgaver">Obligatoriske oppgaver</router-link></p>
      <p><router-link to="/adminpanel/opptaksprøver">Opptaksprøver</router-link></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "SideBarNav",
  data() {
    return {
      adminPanel: false,
      students: false,
      submissions: false,
    };
  },
  methods: {
    AdminPanelShow() {
      this.adminPanel = !this.adminPanel;
    },
    StudentPanelShow() {
      this.students = !this.students;
    },
    SubmissionsPanelShow() {
      this.submissions = !this.submissions;
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-container {
  width: 200px;
  border: 1px solid var(--primary-border-color);
  margin: 0 15px;
  padding: 15px;
}
</style>